'use client'

import React, { useEffect, useState } from 'react'
import { useScroll } from '../../global/ScrollContext'
import { cx } from '@/src/styles/stylebook'
import { usePathname } from 'next/navigation'
import useScreenSize from '@/src/hooks/useScreenSize'

interface ScrollContainerProps {
  children: React.ReactNode
  threshold?: number
  compactHeight?: string
  normalHeight?: string
  className?: string
}

const ScrollContainer = ({ children, threshold = 50, className = '' }: ScrollContainerProps) => {
  const { scrollY, isAtTop } = useScroll()
  const { width } = useScreenSize()
  const [isCompact, setIsCompact] = useState(false)
  const pathname = usePathname()

  useEffect(() => {
    setIsCompact(scrollY > threshold)
  }, [scrollY])

  useEffect(() => {
    if (width < 768) {
      // 모바일에서는 globals.css의 미디어 쿼리 값을 사용하도록 인라인 스타일 제거
      document.body.style.removeProperty('--headerh')
      return
    }
    if (isCompact) {
      document.body.style.setProperty(
        '--headerh',
        width < 1920
          ? '103px'
          : 'calc((0.4vw + 8px) * 2 + calc((0.4vw + 8px) * 1.5) + var(--spacing-gutter) * 3)'
      )
    } else {
      document.body.style.setProperty(
        '--headerh',
        width < 1920
          ? '115px'
          : 'calc((0.4vw + 8px) * 2 + calc((0.4vw + 8px) * 1.5) + var(--spacing-gutter) * 5)'
      )
    }
  }, [isCompact, width])

  return (
    <header
      className={cx(
        'pl-marg pr-gutter flex items-start justify-between pt-[0.6875rem]',
        'top-0 h-[var(--headerh)] transition-all duration-300 ease-in-out',
        isCompact ? 'bg-system-gnbbg' : 'md:mix-blend-multiply',
        className,
        pathname === '/' ? '!fixed' : 'sticky'
      )}
    >
      {children}
    </header>
  )
}

export default ScrollContainer
